import React, { PropsWithChildren } from "react";
import { StyledTooltipBody } from "./tooltip-body.styles";

export const TooltipBody = (props: PropsWithChildren<any>) => (
  <StyledTooltipBody>{props.children}</StyledTooltipBody>
);
